<template>
  <div>
      <v-card v-if="view === 'login'" class="pa-5">
          <v-row class="my-2 pa-5">
            <v-btn block dark color="#e06555"  @click="googleLogin()">
              <v-icon left>
                mdi-google
              </v-icon>
              Login with Google
            </v-btn>
          </v-row>
          
          <v-divider></v-divider>
          <v-form>
            <v-row class="mx-5">
              <v-text-field
                label="Email"
                autocomplete="chrome-off"
                name="Username"
                v-model="login"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>
            </v-row>

            <v-row class="mx-5">
              <v-text-field
                id="password"
                label="Password"
                v-model="password"
                autocomplete="chrome-off"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (showPassword = !showPassword)"
                :type="showPassword ? 'text' : 'password'"
                name="password"
                prepend-icon="mdi-lock"
              ></v-text-field>
            </v-row>
            <v-row class="justify-center">
              <a class="caption" @click="view = 'restore'">I forgot my password</a>
            </v-row>

          <v-row class="ma-5 justify-center">
            <v-btn @click="emailLogin()" color="primary">
              Login
            </v-btn>
          </v-row>
          </v-form>

          <v-divider></v-divider>

          <v-row class="ma-5 justify-center">
            <v-btn @click="view = 'registration'" color="success">
              Email registration
            </v-btn>
          </v-row>

      </v-card>

      <v-card v-if="view === 'registration'" class="pa-5">
        <v-row class="mx-5">
          <v-btn @click="view = 'login'" icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center">
          <p class="text-center red--text">
            {{message}}
          </p>
        </v-row>
        <v-form ref="regForm">
        <v-row class="mx-5">
          <v-text-field
            label="email"
            name="login"
            v-model="login"
            prepend-icon="mdi-account"
            type="text"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
        </v-row>

        <v-row class="mx-5">
          <v-text-field
            id="password"
            label="password"
            v-model="password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            prepend-icon="mdi-lock"
            :rules="[rules.required, rules.min]"
          ></v-text-field>
        </v-row>

        <v-row class="ma-5 justify-center">
          <v-btn @click="emailRegistration()" color="primary">
            Email Registration
          </v-btn>
        </v-row>
        </v-form>
      </v-card>

      <v-card v-if="view === 'restore'" class="pa-5">
        <v-row class="mx-5">
          <v-btn @click="view = 'login'" icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center">
          <p class="text-center red--text">
            {{message}}
          </p>
        </v-row>
        <v-form ref="regForm">
        <v-row class="mx-5">
          <v-text-field
            label="email"
            name="login"
            v-model="login"
            prepend-icon="mdi-account"
            type="text"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
        </v-row>
        <v-row class="ma-5 justify-center">
            <v-btn @click="emailResetPassword()" color="primary">
             Reset password
            </v-btn>
        </v-row>
        </v-form>
      </v-card>

  </div>
</template>


<script>
  export default {
    data() {
      return {
        showPassword : true,
        message : null,
        view : "login",
        login : "",
        password : "",
        rules: {
          required: v => !!v || "required",
          min: v => v.length >= 8 || "min8chars",
          email: v => v.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)  || "invalidEmail",
        },
      }
    },
    methods: {
      async googleLogin() {
        let response = await this.$firebase.auth().signInWithPopup(this.$googleAuthProvider)
      },
      async facebookLogin() {
        let response = await this.$firebase.auth().signInWithPopup(this.$facebookAuthProvider)
      },
      async emailLogin() {
        let response = await this.$firebase.auth().signInWithEmailAndPassword(this.login, this.password)
      },
      async emailResetPassword() {
        try {
          let response = await this.$firebase.auth().sendPasswordResetEmail(this.login)
          this.view = "login"
        } catch (error) {
          this.message = "cantRestorePassword"
        }
      },
      async emailRegistration() {
        if(!this.$refs.regForm.validate()) {
          return
        }
        try {
          let response = await this.$firebase.auth().createUserWithEmailAndPassword(this.login, this.password)
          this.view = "login"
        }
        catch(error) {
          this.message = "registrationFailed"
        }
        
      }
    },
  }
</script>